import m from "mithril"
import { MithrilTsxComponent } from "mithril-tsx-component"
import * as State from "../../editor/state"
import "./header.scss"
import { Icon } from "../../../components/Icon"

export class HeaderMobile extends MithrilTsxComponent<{}> {
  view(v) {
    const product = State.getProduct()
    const zoom = State.getZoom()

    return <div className="Header">
      <div className="product">
        <span>{product.title}</span>
      </div>
      <div className="side">
        <div className="contact"><button onclick={State.showContactDialog}><Icon icon="contact_support" /></button></div>
        <button onclick={e => State.setSidePrev(product)}><Icon icon="chevron_left" /></button>
        <button onclick={e => State.setSideNext(product)}><span>{State.getSide(product).title}</span></button>
        <button onclick={e => State.setSideNext(product)}><Icon icon="chevron_right" /></button>
        <div className="zoom"><button onclick={e => State.toggleZoom()}><Icon icon={zoom ? "zoom_out" : "zoom_in"} /></button></div>
      </div>
    </div>
  }
}

export class HeaderDesktop extends MithrilTsxComponent<{}> {
  view(v) {
    const product = State.getProduct()

    return <div className="Header">
      <div className="product">
        <span>{product.title}</span>
      </div>
      <div className="side">
        <button onclick={e => State.setSidePrev(product)}><Icon icon="chevron_left" /></button>
        <button onclick={e => State.setSideNext(product)}><span>{State.getSide(product).title}</span></button>
        <button onclick={e => State.setSideNext(product)}><Icon icon="chevron_right" /></button>
      </div>
    </div>
  }
}